module.exports = __webpack_public_path__ + "static/media/monitor.0f1222c0.svg";